export enum RegistrationFormType {
    REGISTER = 'register',
    EDIT = 'edit',
}
